/**
 * useTheme
 * CCH Care — Phase 5f
 *
 * Manages light/dark theme toggle.
 * - Persists preference to localStorage under 'cch_care_theme'
 * - Applies data-theme="dark" | "light" to document.documentElement
 *   so CSS variables in index.css take effect
 * - Initialises synchronously in useState to prevent flash on page load
 */

import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'cch_care_theme';

function applyTheme(dark) {
  document.documentElement.setAttribute('data-theme', dark ? 'dark' : 'light');
}

export default function useTheme() {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY) === 'dark';
    // Apply synchronously during initialisation to prevent flash
    applyTheme(saved);
    return saved;
  });

  // Keep DOM + localStorage in sync whenever isDark changes
  useEffect(() => {
    applyTheme(isDark);
    localStorage.setItem(STORAGE_KEY, isDark ? 'dark' : 'light');
  }, [isDark]);

  const toggleTheme = useCallback(() => {
    setIsDark(prev => !prev);
  }, []);

  return { isDark, toggleTheme };
}
